if (!customElements.get('region-form')) {
    customElements.define(
      'region-form',
      class RegionForm extends HTMLElement {
        constructor() {
          super();
          this.mql = window.matchMedia('(min-width: 750px)');
          this.header = document.querySelector('.header-wrapper');
          this.elements = {
            input: this.querySelector('input[name="country_code"]'),
            button: this.querySelector('button.localization-form__select'),
            panel: this.querySelector('.disclosure__list-wrapper'),
            closeButton: this.querySelector('.country-selector__close-button'),
            liveRegion: this.querySelector('#sr-country-search-results'),
            submitButton: this.querySelector('.submit-btn'),
          };
          this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
          this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
          this.addEventListener('focusout', this.closeSelector.bind(this));
          
          if (this.elements.button) {
            this.elements.button.addEventListener('click', this.openSelector.bind(this));
          }
        
          if (this.elements.closeButton) {
            this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
          }
        
          if (this.elements.submitButton) {
            this.elements.submitButton.addEventListener('click', this.onSubmitClick.bind(this));
          }
  
          this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        }
  
        hidePanel() {
          this.elements.button.setAttribute('aria-expanded', 'false');
          this.elements.panel.setAttribute('hidden', true);
        
          document.body.classList.remove('overflow-hidden-mobile');
          const menuDrawer = document.querySelector('.menu-drawer');
          if (menuDrawer) {
            menuDrawer.classList.remove('country-selector-open');
          }
          if (this.header) {
            this.header.preventHide = false;
          }
        }
  
        onContainerKeyDown(event) {
          const focusableItems = Array.from(this.querySelectorAll('a')).filter(
            (item) => !item.parentElement.classList.contains('hidden')
          );
          let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          let itemToFocus;
  
          switch (event.code.toUpperCase()) {
            case 'ARROWUP':
              event.preventDefault();
              itemToFocus =
                focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
              itemToFocus.focus();
              break;
            case 'ARROWDOWN':
              event.preventDefault();
              itemToFocus =
                focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
              itemToFocus.focus();
              break;
          }
  
          setTimeout(() => {
            focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          });
        }
  
        onContainerKeyUp(event) {
          event.preventDefault();
  
          switch (event.code.toUpperCase()) {
            case 'ESCAPE':
              if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
              this.hidePanel();
              event.stopPropagation();
              this.elements.button.focus();
              break;
            case 'SPACE':
              if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
              this.openSelector();
              break;
          }
        }

        setCookie(name, value, days = 365) {
            const expirationDate = new Date();
            expirationDate.setTime(expirationDate.getTime() + (days * 24 * 60 * 60 * 1000));
            const expires = expirationDate.toUTCString();
            document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${expires}; SameSite=Lax`;
        }

        onSubmitClick(event) {
            event.preventDefault();
            
            const market = this.elements.button.dataset.market;
            const currency = this.elements.button.dataset.currency;
            
            if (!market || !currency) {
                alert('Please select a region first');
                return;
            }
            
            // Store cookies with 1 year expiration
            this.setCookie('region', market, 365);
            this.setCookie('cart_currency', currency, 365);
            
            // Verify cookies were set
            const regionCookie = this.getCookie('region');
            const currencyCookie = this.getCookie('cart_currency');
            
            if (!regionCookie || !currencyCookie) {
                alert('Failed to save region selection. Please try again.');
                return;
            }
            
            // Find country code from available countries if needed
            let countryCode = this.elements.button.dataset.countryCode;
            if (!countryCode) {
                // Find the first country that uses this currency
                const matchingLink = Array.from(this.querySelectorAll('a[data-value]')).find(
                    link => link.dataset.value === currency && link.dataset.market === market
                );
                if (matchingLink && matchingLink.dataset.countryCode) {
                    countryCode = matchingLink.dataset.countryCode;
                }
            }
            
            // Update Shopify cart currency via API without redirecting
            this.updateShopifyCurrency(countryCode, currency);
        }

        getCookie(name) {
            const nameEQ = name + '=';
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
            }
            return null;
        }

        async updateShopifyCurrency(countryCode, currency) {
            try {
                // Update the hidden input with country code if we have it
                if (countryCode && this.elements.input) {
                    this.elements.input.value = countryCode;
                }
                
                // Get the form element
                const form = this.querySelector('form');
                if (!form) {
                    this.closeModalAndReload();
                    return;
                }
                
                // Create a temporary iframe to submit the form without redirecting
                const iframe = document.createElement('iframe');
                iframe.name = 'localization-iframe';
                iframe.style.display = 'none';
                document.body.appendChild(iframe);
                
                // Set form target to the iframe
                const originalTarget = form.target;
                form.target = 'localization-iframe';
                
                // Submit the form - it will submit to the iframe, not redirect the page
                form.submit();
                
                // Wait a moment for the form to process, then clean up
                setTimeout(() => {
                    // Restore original form target
                    form.target = originalTarget;
                    // Remove the iframe
                    document.body.removeChild(iframe);
                    
                    // Close modal and reload
                    this.closeModalAndReload();
                }, 500);
                
            } catch (error) {
                this.closeModalAndReload();
            }
        }

        closeModalAndReload() {
            // Close the modal
            const modal = document.getElementById('langModal');
            if (modal) {
                modal.classList.add('hidden');
                // Re-enable background scrolling when modal is closed
                document.body.classList.remove('overflow-hidden');
            }
            
            // Reload the page to apply the currency change
            window.location.reload();
        }
  
        onItemClick(event) {
            event.preventDefault();
            
            this.hidePanel();
            const selectedCurrency = event.currentTarget.dataset.value;
            const selectedMarket = event.currentTarget.dataset.market;
            const selectedMarketLabel = event.currentTarget.dataset.label;
            const selectedCountryCode = event.currentTarget.dataset.countryCode;
            
            // Get the currency symbol from the clicked element
            const currencySymbolElement = event.currentTarget.querySelector('.localization-form__currency');
            const selectedCurrencySymbol = currencySymbolElement ? currencySymbolElement.textContent.trim() : selectedCurrency;
            
            this.elements.button.dataset.market = selectedMarket;
            this.elements.button.dataset.currency = selectedCurrency;

            if (selectedCountryCode) {
                this.elements.button.dataset.countryCode = selectedCountryCode;
            }

            // Update button label for non-slim forms
            const form = this.querySelector('form');
            const isSlimForm = form && form.classList.contains('slim-form');
            
            if (!isSlimForm) {
              // For full forms, update the button text to show the selected region
              const regionLabel = this.elements.button.querySelector('.region-label');
              if (regionLabel) {
                regionLabel.textContent = `Region: ${selectedMarketLabel}`;
              }
            }

            // Update currency symbol if it exists outside the form
            const currencyDisplay = document.querySelector('[data-currency-symbol]');
            if (currencyDisplay && selectedCurrencySymbol) {
              currencyDisplay.textContent = selectedCurrencySymbol;
            }

            // If this is a slim-form, automatically submit when a region is selected
            if (isSlimForm) {
                // Create a synthetic click event on the submit button to trigger onSubmitClick
                if (this.elements.submitButton) {
                    this.elements.submitButton.click();
                } else {
                    // If no submit button, call onSubmitClick directly with a synthetic event
                    const syntheticEvent = { preventDefault: () => {} };
                    this.onSubmitClick(syntheticEvent);
                }
            }
        }
  
        openSelector() {
          this.elements.button.focus();
          this.elements.panel.toggleAttribute('hidden');
          this.elements.button.setAttribute(
            'aria-expanded',
            (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
          );
          if (!document.body.classList.contains('overflow-hidden-tablet')) {
            document.body.classList.add('overflow-hidden-mobile');
          }
          if (this.hasAttribute('data-prevent-hide') && this.header) {
            this.header.preventHide = true;
          }
          const menuDrawer = document.querySelector('.menu-drawer');
          if (menuDrawer) {
            menuDrawer.classList.add('country-selector-open');
          }
        }
  
        closeSelector(event) {
          if (
            event.target.classList.contains('country-selector__overlay') ||
            !this.contains(event.target) ||
            !this.contains(event.relatedTarget)
          ) {
            this.hidePanel();
          }
        }
  
      }
    );
  }
  